/**
 * GET User CREDIT CARDS Action
 */
import * as _ from 'lodash-es';

import {
  ACTION_GET_USER_CREDITCARDS,
  ACTION_GET_USER_CREDITCARDS_SUCCESS,
  ACTION_GET_USER_CREDITCARDS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbar } from '../Status';

/**
 * GET User Request Action
 */
export function get(userId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    // Dispatch the api call request.
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `user/${userId}/creditcards`,
        method: 'get',
        success: (response: any) => {
          if (response.type === 'error') {
            const errors = _.get(response, 'payload.payload', {});
            Object.keys(errors).forEach(function (item) {
              if (_.get(errors, item, false) === true) {
                dispatch(enqueueSnackbar(item, 'error'));
              }
            });
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          const errors = _.get(error, 'payload', {});
          Object.keys(errors).forEach(function (item) {
            if (_.get(errors, item, false) === true) {
              dispatch(enqueueSnackbar(item, 'error'));
            }
          });
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_USER_CREDITCARDS,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_USER_CREDITCARDS_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_USER_CREDITCARDS_FAILURE,
    payload: responseJSON,
  };
}
